/**
 * Think dock turn mode — forwarded on each `useAgentChat` / `sendMessage` body.
 * Server: `packages/rscircuit-agent/src/turn-mode.ts` (`turnModeOf`).
 * View rev: `think-view-rev.ts` → agent `view-rev.ts` (`viewRevOf`).
 */

export const PCBX_TURN_MODE_BODY_KEY = "pcbx_turn_mode";

export type PcbxTurnMode = "qa" | "edit";

export function thinkChatBodyForMode(mode: PcbxTurnMode): Record<string, PcbxTurnMode> {
  return { [PCBX_TURN_MODE_BODY_KEY]: mode };
}
